import Breadcrumb from '../../ui/components/Breadcrumb';
import HelpContactCard from '../../ui/components/HelpContactCard';
import MainContentArticle from '../../ui/components/MainContentArticle';
import MainSection from '../../ui/components/MainSection';
import MultiColorDivider from '../../ui/components/MultiColorDivider';
import SideBarNav from '../../ui/components/SideBarNav';
import PageTitle from '../buyerAndVendor/PageTitle';
import PoliciesMainContent from '../../ui/components/PoliciesMainContent';
import TopArticleCards from '../../ui/components/TopArticleCards';
import BuyingGuidePolicy from './BuyingGuidePolicy';

const routes = [
  { name: 'SmallSmall', href: '/' },
  { name: 'Support', href: '/' },
  { name: 'Buying guide', href: '/' },
];

export const dataContent = [
  { label: 'Marketplace guidelines', link: '/marketplace-guidelines' },
  {
    label: 'Buyer protection',
    link: '/buyer-vendor-protection',
  },
];

function BuyingGuide() {
  // return <div>Refunds and Returns</div>;
  return (
    <PoliciesMainContent>
      <Breadcrumb routes={routes} />
      <PageTitle title="Buying guide" />
      {/* <TopArticleCards title="Buying guide" /> */}
      <MultiColorDivider />
      <MainSection>
        <SideBarNav title="Buying articles" data={dataContent} />
        <MainContentArticle title="Buyer's Guide">
          <BuyingGuidePolicy />
        </MainContentArticle>
      </MainSection>
      <HelpContactCard />
    </PoliciesMainContent>
  );
}

export default BuyingGuide;
